module.exports = __webpack_public_path__ + "img/profile2.792071da.png";